import React from "react";
import { useState, useEffect } from "react";
import TopHeader from "../../../Components/TopHeader";
import Prince from "../../../Components/Prince";
import { DateRangePicker } from "react-date-range";
import { format } from "date-fns";
import spiner from "../../../assets/img/spiner.gif";
import { MdDateRange } from "react-icons/md";
import FilterComponent from "../ReportComponent/FilterComponent";
import CardComponent from "../ReportComponent/CardComponent";

import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ExportButton from "../../../Components/ExportButton";
//import { data } from "jquery";

function ClosureReport({}) {
  const apiUrl = process.env.REACT_APP_URL;
  const Token = localStorage.getItem("_ux98c_v1");

  const [dateFilterModalOPen, setDateFilterModalOpen] = useState(false);
  // const [modelOpen, setModalOpen] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  const [counts, setCounts] = useState([]);
  const [wonLeadBySource, setWonLeadBySource] = useState([]);
  const [wonLeadByStage, setWonLeadByStage] = useState([]);
  const [wonLeadByState, setWonLeadByState] = useState([]);
  const [wonleadByPerSalesAgent, setWonLeadByPerSalesAgent] = useState([]);
  const [wonVsLost, setWonVsLost] = useState([]);
  const [leadSourceOptions, setLeadSourceOptions] = useState([]);
  const [employeeId, setEmployeeId] = useState([]);
  const [state, setStates] = useState([]);
  const [leadStatus, setLeadStatus] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [allSourceCount, setAllSourceCount] = useState(null);
  const [allStateCount, setAllStateCount] = useState(null);
  const [allPerSaleCount, setAllPerSaleCount] = useState(null);

  const onFilterChange = (data) => {
    setFilterData(data);
  };

  const [date, setDate] = useState(null);

  // console.log(filterData.filterByLeadPipeline);
  // console.log(employeeId);

  const handleDateFilterClick = () => {
    setDateFilterModalOpen(true);
  };
  const handleCloseDateFilterModal = () => {
    setDateFilterModalOpen(false);
  };

  const handleDateChange1 = (ranges) => {
    const adjustedStartDate = new Date(ranges.selection.startDate);
    adjustedStartDate.setUTCDate(adjustedStartDate.getUTCDate() + 1); // Subtract one day
    adjustedStartDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    const adjustedEndDate = new Date(ranges.selection.endDate);
    adjustedEndDate.setUTCDate(adjustedEndDate.getUTCDate() + 1); // Add one day
    adjustedEndDate.setUTCHours(0, 0, 0, 0); // Set time to 00:00:00 UTC

    setFrom(adjustedStartDate.toISOString()); // Convert to UTC string format
    setTo(adjustedEndDate.toISOString());
    setDate(ranges.selection);

    if (
      ranges.selection.startDate &&
      ranges.selection.endDate &&
      ranges.selection.startDate.getTime() !==
        ranges.selection.endDate.getTime()
    ) {
      handleCloseDateFilterModal(); // close modal
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        };
        const response = await fetch(`${apiUrl}/closureReport/headerCount`, {
          method: "GET",
          headers: headers,
        });
        const result = await response.json();
        setCounts(result.data);
      } catch (err) {
        toast.error(err.message);
      }
    };

    fetchData();
  }, []);

  // useEffect(() => {
  const fetchData4 = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/closureReport/wonLeadCountSource?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setAllSourceCount(result.overallTotals);
      setWonLeadBySource(result.data);
    } catch (err) {
      toast.error(err.message);
    }
  };

  // fetchData4();
  // }, []);

  // useEffect(() => {
  const fetchData3 = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/closureReport/wonLeadCountStage?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setWonLeadByStage(result.data);
      setAllStateCount(result.overallTotals);
    } catch (err) {
      toast.error(err.message);
    }
  };

  //fetchData3();
  // }, []);

  // useEffect(() => {
  const fetchData2 = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/closureReport/wonLeadCountState?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setWonLeadByState(result.data);
      setAllPerSaleCount(result.overallTotals);
    } catch (err) {
      toast.error(err.message);
    }
  };

  // fetchData2();
  // }, []);

  // useEffect(() => {
  const fetchData1 = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/closureReport/wonLeadPerSalesAgent?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setWonLeadByPerSalesAgent(result.data);
      setAllPerSaleCount(result.overallTotals);
    } catch (err) {
      toast.error(err.message);
    }
  };

  // }, []);

  // useEffect(() => {
  const fetchData = async () => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Token}`,
      };
      const response = await fetch(
        `${apiUrl}/closureReport/wonVsLost?from=${from}&to=${to}&leadSource=${
          filterData.filterByLeadSource || ""
        }&employeeId=${filterData.filterByLeadPipeline || ""}&status=${
          filterData.filterByBusinessCategory || ""
        }&state=${filterData.filterByPartner || ""}`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const result = await response.json();
      setWonVsLost(result.data);
    } catch (err) {
      toast.error(err.message);
    }
  };

  // }, []);
  useEffect(() => {
    fetchData();
    fetchData1();
    fetchData2();
    fetchData3();
    fetchData4();
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/1`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadSourceOptions(data.data);
        }
      });

    fetch(`${apiUrl}/employee/allStates/101`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setStates(data.data);
        }
      })
      .catch((error) => {
        // console.error("Error fetching gender options:", error);
      });
  }, []);

  useEffect(() => {
    // Make an API request to fetch gender options
    fetch(`${apiUrl}/master/getAllMasterData/8`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setLeadStatus(data.data);
        }
      });
  }, []);

  useEffect(() => {
    fetch(`${apiUrl}/employee/empDropdownSub`, {
      headers: {
        Authorization: `Bearer ${Token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data && Array.isArray(data.data)) {
          setEmployeeId(data.data);
        }
      })
      .catch((error) => {});
  }, []);

  const handleApplyFilter = () => {
    fetchData();
    fetchData1();
    fetchData2();
    fetchData3();
    fetchData4();
  };
  return (
    <>
      <div className="page">
        <TopHeader />
        <Prince />
        <div className="main-content side-content pt-0 m-0">
          <div className="main-container container-fluid">
            <div className="inner-body">
              <div className="page-header my-2">
                <div>
                  <h2 className="main-content-title tx-24 mb-0 mt-1 ">
                    Closure Report
                  </h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Closure Report
                    </li>
                  </ol>
                </div>
              </div>
              <div style={{ marginTop: "15px" }}>
                <div className="row">
                  <CardComponent
                    title={"Total Won Lead Daily"}
                    link={"Won Lead Daily"}
                    count={counts.dailyWonLeadCount}
                  />
                  <CardComponent
                    title={"Total Won Lead Weekly"}
                    link={"Won Lead Weekly"}
                    count={counts.weeklyWonLeadCount}
                  />
                  <CardComponent
                    title={"Total Won Lead Monthly"}
                    link={"Won Lead Monthly"}
                    count={counts.monthlyWonLeadCount}
                  />
                  <CardComponent
                    title={"Total Won Lead Quarterly"}
                    link={"Won Lead Quarterly"}
                    count={counts.quaterlyWonLeadCount}
                  />
                  <CardComponent
                    title={"Total Won Lead Yearly"}
                    link={"Won Lead Yearly"}
                    count={counts.yearlyWonLeadCount}
                  />

                  <div className="card custom-card">
                    <div className="card-body py-0 pb-3">
                      <div className="row">
                        <div className="col-sm-2 mt-3">
                          <label>Date Filter</label>
                          <div>
                            <button
                              className="calender btn btn-outline-danger"
                              onClick={handleDateFilterClick}
                              style={{
                                fontSize: "11px",
                                // width: "215px",
                              }}
                            >
                              <MdDateRange
                                size={16}
                                style={{ display: "inline" }}
                              />{" "}
                              {date
                                ? `${format(
                                    date.startDate,
                                    "MMM dd yyyy"
                                  )} -- ${format(date.endDate, "MMM dd yyyy")}`
                                : "Select Calender Date"}
                            </button>
                          </div>
                          <div
                            className={`modal ${
                              dateFilterModalOPen ? "show" : ""
                            } bg-black-7`}
                            style={{
                              display: dateFilterModalOPen ? "block" : "none",
                            }}
                            tabIndex="-1"
                            role="dialog"
                          >
                            <div
                              className=" modal-dialog modal-dialog modal-lg"
                              role="document"
                              style={{ marginTop: "80px" }}
                            >
                              <div
                                className="modal-content"
                                style={{ borderRadius: "8px" }}
                              >
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Select Date Range
                                  </h5>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                    onClick={handleCloseDateFilterModal}
                                  >
                                    <span aria-hidden="true">&times;</span>
                                  </button>
                                </div>
                                <div
                                  className="modal-body"
                                  style={{ width: "100%" }}
                                >
                                  <DateRangePicker
                                    // ranges={[date]}
                                    ranges={
                                      date
                                        ? [date]
                                        : [
                                            {
                                              startDate: new Date(),
                                              endDate: new Date(),
                                              key: "selection",
                                            },
                                          ]
                                    }
                                    onChange={handleDateChange1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <FilterComponent
                          leadSourceOptions={leadSourceOptions}
                          // leadPipelineOptions={employees}
                          leadStatus={[
                            { id: "Won", name: "Won" },
                            { id: "Lost", name: "Lost" },
                            { id: "Open", name: "Open" },
                          ]}
                          partnerOptions={state}
                          employeeId={employeeId}
                          onFilterChange={onFilterChange}
                        />
                        <div className="d-flex">
                          <div className="mr-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-success"
                              onClick={handleApplyFilter}
                            >
                              Apply Filter
                            </button>
                          </div>
                          <div className="mx-2">
                            <button
                              style={{ marginTop: "30px" }}
                              className="btn btn-outline-warning"
                              onClick={() => {
                                setDate({
                                  startDate: new Date(),
                                  endDate: new Date(),
                                  key: "selection",
                                });
                                window.location.reload();
                              }}
                            >
                              Clear Filter
                            </button>
                          </div>
                        </div>
                      </div>{" "}
                    </div>
                  </div>
                  <div className="d-flex">
                    <CardComponent
                      title={"Total Won Lead"}
                      link={"Total Won Lead"}
                      count={wonVsLost.wonLeadReport}
                      totalLead={wonVsLost.report}
                      percentage={wonVsLost.wonLeadPercentage}
                    />
                    <CardComponent
                      title={"Total Lost Lead"}
                      link={"Total Lost Lead"}
                      count={wonVsLost.lostLeadReport}
                      totalLead={wonVsLost.report}
                      percentage={wonVsLost.lostLeadPercentage}
                    />
                    <CardComponent
                      title={"Total Open Lead"}
                      link={"Total Open Lead"}
                      count={wonVsLost.openLeadReport}
                      totalLead={wonVsLost.report}
                      percentage={wonVsLost.openLeadPercentage}
                    />
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Won Lead By Lead Source
                        </h5>

                        <div
                          class="table-responsive"
                          style={{ overflowY: "auto", height: "500px" }}
                        >
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Lead Source</th>
                                <th scope="col">Total Leads</th>
                                <th scope="col">Open Leads</th>
                                <th scope="col">Won Leads</th>

                                <th scope="col">Lost Leads</th>
                                <th scope="col">Total Order</th>
                                <th scope="col">Total Shipment</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wonLeadBySource?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item?.leadSource}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {item?.totalLeads}
                                    </a>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      // to={"/leads/Open"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.openLeads}{" "}
                                      </span>{" "}
                                      ({item?.openLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/Won"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.wonLeads}{" "}
                                      </span>{" "}
                                      ({item.wonLeadPer})
                                    </Link>
                                  </td>

                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.lostLeads}{" "}
                                      </span>{" "}
                                      ({item.lostLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    {/* <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    > */}
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalOrder}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                  <td data-label="Lead Score">
                                    {/* <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    > */}
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalShipment}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span className="font-bold">Total</span>
                                </td>
                                <td data-label="Phone">
                                  <span
                                    className="font-bold"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {allSourceCount?.totalLeads}
                                  </span>
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allSourceCount?.openLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allSourceCount?.wonLeads}
                                  </span>{" "}
                                </td>

                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allSourceCount?.lostLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allSourceCount?.totalOrder}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  {/* <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    > */}
                                  <span className="font-bold">
                                    {" "}
                                    {allSourceCount?.totalShipment}
                                  </span>{" "}
                                  {/* </Link> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/closureReport/wonLeadPerSalesAgentExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Won Lead By Lead State
                        </h5>

                        <div
                          class="table-responsive"
                          style={{ overflowY: "auto", height: "500px" }}
                        >
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Lead State</th>
                                <th scope="col">Total Lead</th>
                                <th scope="col">Open Lead</th>
                                <th scope="col">Won Lead</th>
                                <th scope="col">Lost Lead</th>
                                <th scope="col">Total Order</th>
                                <th scope="col">Total Shipment</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wonLeadByState?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item?.leadSource}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      // href="mailto:robert.fox@example.com"
                                    >
                                      {item?.totalLeads}
                                    </a>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      // to={"/leads/Open"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.openLeads}{" "}
                                      </span>{" "}
                                      ({item.openLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/Won"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.wonLeads}{" "}
                                      </span>{" "}
                                      ({item.wonLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/lost"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.lostLeads}{" "}
                                      </span>{" "}
                                      ({item.lostLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalOrder}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                  <td data-label="Lead Score">
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalShipment}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span className="font-bold">Total</span>
                                </td>
                                <td data-label="Phone">
                                  <span
                                    className="font-bold"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {allStateCount?.totalLeads}
                                  </span>
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allStateCount?.openLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allStateCount?.wonLeads}
                                  </span>{" "}
                                </td>

                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allStateCount?.lostLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allStateCount?.totalOrder}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  {/* <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    > */}
                                  <span className="font-bold">
                                    {" "}
                                    {allStateCount?.totalShipment}
                                  </span>{" "}
                                  {/* </Link> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/closureReport/wonLeadByStateExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="card custom-card">
                      <div className="card-body">
                        <h5 style={{ textDecoration: "underline" }}>
                          Won Lead By Per Sales Agent
                        </h5>

                        <div
                          class="table-responsive"
                          style={{ overflowY: "auto", height: "500px" }}
                        >
                          <table class="table table-hover table-nowrap">
                            <thead class="table-light">
                              <tr>
                                <th scope="col">Sales Agent</th>
                                <th scope="col">Total Lead</th>
                                <th scope="col">Open Lead</th>
                                <th scope="col">Won Lead</th>
                                <th scope="col">Lost Lead</th>
                                <th scope="col">Total Order</th>
                                <th scope="col">Total Shipment</th>
                              </tr>
                            </thead>
                            <tbody>
                              {wonleadByPerSalesAgent?.map((item, index) => (
                                <tr key={index}>
                                  <td data-label="Email">
                                    <span>{item?.employeeName}</span>
                                  </td>
                                  <td data-label="Phone">
                                    <a
                                      class="text-current"
                                      //href="mailto:robert.fox@example.com"
                                    >
                                      {item?.totalLeads}
                                    </a>
                                  </td>

                                  <td data-label="Lead Score">
                                    <Link
                                      // to={"/leads/Open"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.openLeads}{" "}
                                      </span>{" "}
                                      ({item.openLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/Won"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.wonLeads}{" "}
                                      </span>{" "}
                                      ({item.wondLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <Link
                                      to={"/leads/lost"}
                                      class="text-current"
                                      state={{ state: item.leadSource }}
                                    >
                                      <span className="text-bold">
                                        {" "}
                                        {item?.lostLeads}{" "}
                                      </span>{" "}
                                      ({item.lostLeadPer})
                                    </Link>
                                  </td>
                                  <td data-label="Lead Score">
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalOrder}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                  <td data-label="Lead Score">
                                    <span className="text-bold">
                                      {" "}
                                      {item?.totalShipment}{" "}
                                    </span>{" "}
                                    {/* </Link> */}
                                  </td>
                                </tr>
                              ))}
                              <tr>
                                <td data-label="Email">
                                  <span className="font-bold">Total</span>
                                </td>
                                <td data-label="Phone">
                                  <span
                                    className="font-bold"
                                    //href="mailto:robert.fox@example.com"
                                  >
                                    {allPerSaleCount?.totalLeads}
                                  </span>
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allPerSaleCount?.openLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allPerSaleCount?.wonLeads}
                                  </span>{" "}
                                </td>

                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allPerSaleCount?.lostLeads}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  <span className="font-bold">
                                    {" "}
                                    {allPerSaleCount?.totalOrder}
                                  </span>{" "}
                                </td>
                                <td data-label="Lead Score">
                                  {/* <Link
                                      to={"/leads/Lost"}
                                      class="text-current"
                                      state={{ leadSource: item?.leadSource }}
                                      //  href="tel:202-555-0152"
                                    > */}
                                  <span className="font-bold">
                                    {" "}
                                    {allPerSaleCount?.totalShipment}
                                  </span>{" "}
                                  {/* </Link> */}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div
                          className="mt-2"
                          style={{ display: "flex", justifyContent: "end" }}
                        >
                          <ExportButton
                            reportUrl={`${apiUrl}/closureReport/wonLeadPerSalesAgentExcel`}
                            filterState={filterData}
                            fileName="OpenLeads_Jan.csv"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Row */}
              </div>

              {}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ClosureReport;
